import { render, staticRenderFns } from "./Form423_v2.vue?vue&type=template&id=01801b85&scoped=true&"
import script from "./Form423_v2.vue?vue&type=script&lang=js&"
export * from "./Form423_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form423_v2.vue?vue&type=style&index=0&id=01801b85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01801b85",
  null
  
)

export default component.exports